module.exports = __webpack_public_path__ + "img/edit.d8419cbb.png";